export default "__VITE_ASSET__w1jhMqdG__"